import { localized } from '@weavedev/lit-i18next';
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Ref, createRef, ref } from 'lit/directives/ref.js';

import { FgPersonalisation } from '@/components';
import { BREAKPOINT_SMALL_PX } from '@/settings';
import { baseStyles } from '@/styles';

import { PrintOptionFilterOptionDto } from '@/api-sdk';
import '@/components/fg-print-option-summary';
import '@/components/personalisation/fg-personalisation';

@customElement('fg-print-option-filter-logo-option')
@localized()
export class FgPrintOptionFilterLogoOption extends LitElement {
  fgPersonalisationDialogRef: Ref<FgPersonalisation> = createRef();

  @property({ type: Object })
  selectedPrintOption?: PrintOptionFilterOptionDto;

  render() {
    if (this.selectedPrintOption === undefined) {
      return null;
    }

    return html`
      <button class="option" @click=${this.handleLogoSupplyChoice}>
        <div>
          <strong class="option-label">
            ${this.selectedPrintOption?.name}
          </strong>

          ${this.selectedPrintOption?.description
            ? html`
                <span class="option-description">
                  ${this.selectedPrintOption.description}
                </span>
              `
            : nothing}
        </div>
      </button>

      ${this.selectedPrintOption?.printOption
        ? html`
            <fg-personalisation
              ${ref(this.fgPersonalisationDialogRef)}
              .hasColorChoice=${this.selectedPrintOption.printOption
                ?.hasColorChoice}
              .printOption=${this.selectedPrintOption.printOption}
              @personalisation-completed=${this.onPrintOptionChange}
            >
              <fg-print-option-summary
                slot="print-option-summary"
                .option=${this.selectedPrintOption.printOption}
              ></fg-print-option-summary>
            </fg-personalisation>
          `
        : nothing}
    `;
  }

  handleLogoSupplyChoice() {
    if (this.selectedPrintOption?.printOption) {
      this.fgPersonalisationDialogRef.value?.openDialog();
      return;
    }
    this.onPrintOptionChange();
  }

  onPrintOptionChange() {
    this.dispatchEvent(
      new CustomEvent('option-selected', {
        composed: true,
        detail: {
          option: {
            queryString: this.selectedPrintOption?.queryString,
          },
        },
      }),
    );
  }

  static styles = [
    baseStyles,
    css`
      .options-list {
        display: grid;
        gap: 5px;
      }

      .option {
        text-align: center;
        height: 100%;
        min-height: 80px;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        border: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
        border-radius: var(--fg-borderradius, var(--fg-fallback-borderradius));
        padding: 8px;
      }

      .option:hover {
        color: var(--fg-primary, var(--fg-fallback-primary));
        border-color: var(--fg-primary, var(--fg-fallback-primary));
        box-shadow: var(--fg-boxshadow, var(--fg-fallback-boxshadow));
      }

      .option-label {
        font-size: 1rem;
        line-height: 1.6;
      }

      .option-description {
        line-height: 1.4;
        display: block;
      }

      @media screen and (min-width: ${BREAKPOINT_SMALL_PX}px) {
        .options-list {
          gap: 10px;
          grid-template-columns: repeat(2, 1fr);
        }
      }
    `,
  ];
}
